import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const Collapsable = ({ text, children, defaultOpen, pb }: ICollapsable) => {
    const [open, setOpen] = useState(defaultOpen)
    const [height, setHeight] = useState('0px')
    const contentRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (open) {
            setHeight(`${contentRef.current.scrollHeight}px`)
        } else {
            setHeight('0px')
        }
    }, [open, children]) // Dodato 'children' ako se menja visina sadržaja dinamički

    return (
        <Container>
            <Flex
                mb='6'
                center
                style={{ cursor: 'pointer' }}
                width='100%'
                onClick={() => setOpen(prev => !prev)}
            >
                <TitleText weight='bold'>{text}</TitleText>
            </Flex>
            <CollapsableContent ref={contentRef} style={{ height, paddingBottom: (open && pb) ? pb : 0 }}>
                {children}
            </CollapsableContent>
        </Container>
    )
}

const Container = styled.div`
${props => props.theme.container};
padding: 1rem;
  width: 100%;
`

const CollapsableContent = styled.div`
  overflow: hidden;
  transition: height 0.3s ease;
`

interface ICollapsable {
    pb?: string
    text: string
    children: any
    defaultOpen?: boolean
}